import { render } from "./AdminTemplates.vue?vue&type=template&id=07c76981"
import script from "./AdminTemplates.vue?vue&type=script&lang=js"
export * from "./AdminTemplates.vue?vue&type=script&lang=js"

import "./AdminTemplates.vue?vue&type=style&index=0&id=07c76981&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__